import axios from "axios";

export const getCheckUploadedAttachment = async (id: string): Promise<boolean> => {
    const response = await axios.get(`booking/substitution/${id}/check-uploaded-attachment`);
    return response.data;
};

export const checkSubstitutionByRa = async (id: string): Promise<any> => {
    const response =  await axios.get("network/search/substitution-by-ra", {params: {idRentalAgreement: id}});
    return response.data;
};
